import {Badge} from "@shopify/polaris"

const StatusBadge = ({status}) => {
	return (
		<Badge status={status && 'success'}>{status ? 'Active' : 'Inactive'}</Badge>
	)
}
export default StatusBadge
